import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./Policies.css";

const SecurityPolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-container">
            <button className="back-button" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <h1>Security Policy</h1>
            <p className="policy-intro">Last Updated: January 5, 2025</p>

            <section className="security-section">
                <h2 className="section-title">Data Protection Measures</h2>

                <div className="content-block">
                    <ul className="list">
                        <li>All user data at rest is encrypted using AES-256 standard encryption.</li>
                        <li>All data in transit is protected using SSL/TLS protocols to prevent interception.</li>
                        <li>We implement secure authentication methods, including optional Two-Factor Authentication (2FA) on supported platforms.</li>
                        <li>Regular vulnerability scans and third-party penetration testing are conducted to ensure the platform remains secure and up to date with the latest threats.</li>
                        <li>Access to backend systems is restricted through role-based permissions and secured by multi-layer authentication controls.</li>
                    </ul>
                </div>

                <h2 className="section-title">Preventing Unauthorized Access</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>We actively monitor login behavior and apply rate-limiting and IP-based restrictions to block brute-force attacks or abnormal access patterns.</li>
                        <li>Users are encouraged to use strong, unique passwords and update them regularly. We do not store passwords in plain text—only hashed using secure cryptographic algorithms (e.g., bcrypt).</li>
                        <li>If suspicious activity is detected or if you believe your account has been compromised, contact us immediately at <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>.</li>
                    </ul>
                </div>

                <h2 className="section-title">Security Breach Protocol</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>In the event of a security incident, our internal team will immediately investigate, contain, and mitigate the issue.</li>
                        <li>We will notify affected users and relevant regulatory authorities within 72 hours if a data breach involving personal information is confirmed, in compliance with data protection laws (e.g., GDPR, CCPA).</li>
                        <li>Post-incident reviews are conducted to prevent recurrence and strengthen system defenses.</li>
                    </ul>
                </div>

                <h2 className="section-title">In-App Messaging Security</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>All in-app messaging is handled securely with end-to-end encryption to protect user communications.</li>
                        <li>Message data is stored securely and is only accessible to authorized users involved in the conversation.</li>
                        <li>We comply with international data protection standards (e.g., GDPR, CCPA) in handling all messaging data.</li>
                        <li>If you wish to manage or delete your chat data, you can request that your account data be erased via our support team at <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>. Please note that deleting your account may impact your ability to use chat features.</li>
                    </ul>
                </div>

                <h2 className="section-title">Use of EmailJS for Reporting Inappropriate Content</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Fervoir uses EmailJS to facilitate user-reported content submissions through in-app forms.</li>
                        <li>The transmitted data includes only necessary metadata (e.g., user ID and report category), never sensitive or personally identifiable information without consent.</li>
                        <li>EmailJS is configured to meet industry data protection and transmission standards and is used strictly within the bounds of our <a href="#privacy-policy" className="link">Privacy Policy</a>.</li>
                    </ul>
                </div>
            </section>

            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>
                <div className="content-block">
                    <p>
                        We reserve the right to update these policies at any time.
                    </p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p>For any questions, concerns, or feedback, please contact us at:</p>
                    <p>
                        Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default SecurityPolicy;